import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FormFieldRadioButtonGroup, Layout, RadioButton } from '@vwfs-bronson/bronson-react'
import { Formik } from 'formik'
import { FormField } from '../../../components/FormField'
import { CustomerRole } from '../../../models/enums'
import getInitialValues from './initial-values'
import { useSelector } from 'react-redux'
import { getStorefrontData } from '../../../services/redux/features/storefront.redux'

interface PreSelectionProps {
  onChange?: (values: any) => void
}

const PreSelection = forwardRef((props: PreSelectionProps , ref) => {
  const { t } = useTranslation()
  const { onChange } = props
  const { storefrontData } = useSelector(getStorefrontData)
  const [formValues, setFormValues] = useState() as any

  useEffect(() => {
    if (onChange) {
      onChange(formValues)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formValues])

  return (
    <Formik
      enableReinitialize
      initialValues={getInitialValues(storefrontData)}
      onSubmit={() => {}}
    >
      {(formProps) => {
        const { values } = formProps
        setFormValues(values)
        return (
          <FormField
            testId="role"
            type="input"
            name="customerData.role"
            required
            render={(fieldProps) => (
              <FormFieldRadioButtonGroup {...fieldProps} >
                <RadioButton
                  name={fieldProps.name}
                  value={CustomerRole.PRIVATE}
                  defaultChecked={values?.customerData?.role === CustomerRole.PRIVATE}
                >
                  {t('personal-details:role:PRIVATE')}
                </RadioButton>
                <RadioButton
                  name={fieldProps.name}
                  value={CustomerRole.BUSINESS}
                  defaultChecked={values?.customerData?.role === CustomerRole.BUSINESS}
                >
                  {t('personal-details:role:BUSINESS')}
                </RadioButton>
              </FormFieldRadioButtonGroup>
            )}
          />
        )
      }}
    </Formik>
  )
})

export default PreSelection